import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import CheckmarkIconOrange from '../../../../assets/icons/checkmark_icon_orange.svg';
import CheckmarkIconGrey from '../../../../assets/icons/checkmark_icon_grey.svg';

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 12px;
`;

export const LabelContainer = styled.label`
  user-select: none;
  display: grid;
  grid-template-columns: 20px auto;
  align-items: center;
  column-gap: 12px;
  margin: 0;
`;

export const Input = styled.input`
  margin: 2px;
  align-self: start;
  cursor: pointer;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #63666A;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: ${colors.WHITE};

  &:checked {
    background-position: center center;
    background-repeat: no-repeat;
    background-image: ${({ disabled }) =>
    (disabled ? `url(${CheckmarkIconGrey})` : `url(${CheckmarkIconOrange})`)};
    border-color: ${colors.BRAND_ORANGE};
    border-width: 2px;
  }

  &:focus {
    outline: #FFDFD0 solid 3px;
  }

  &:hover {
    outline: #FFDFD0 solid 3px;
  }

  &:disabled {
    cursor: not-allowed;
    border: 1px solid ${colors.GREY_MEDIUM};

    &:hover {
      outline: none;
    }
  }
`;

export const Text = styled.p`
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  color: ${colors.BLACK};
  margin: 0;

  &:disabled {
    color: ${colors.DARK_GREY};
    cursor: not-allowed;
  }
`;
